import { render, staticRenderFns } from "./raise-data.vue?vue&type=template&id=290cf793&scoped=true&"
import script from "./raise-data.vue?vue&type=script&lang=js&"
export * from "./raise-data.vue?vue&type=script&lang=js&"
import style0 from "./raise-data.vue?vue&type=style&index=0&id=290cf793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290cf793",
  null
  
)

export default component.exports